import React, { useState, useEffect, forwardRef } from "react";
import { EmailShareButton, FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";
import Image from "../Image";
import facebook from "../../icons/blog_facebook.svg";
import x from "../../icons/blog_x.svg";
import linkedin from "../../icons/blog_linkedin.svg";
import email from "../../icons/blog_email.svg";
import footerLogo from "../../icons/blog_mountain_america_footer.svg";
import footerLogoSmall from "../../icons/blog_mountain_america_footer_small.svg";
import ShareButtons from "./ShareButtons";
import IStyledProps from "../../utilities/IStyledProps";
import IEditableProps from "../../utilities/IEditableProps";
import classNames from "classnames";
import Picture from "../Picture";

export interface IBlogFooterButtonsProps extends IStyledProps, IEditableProps {
    gutterClass: string;
}

const BlogFooterButtons = forwardRef(({ gutterClass = "mr-xl-3 mr-2", cmsId, editorClassObj }: IBlogFooterButtonsProps, ref: any) => {
    const [url, setUrl] = useState(null);

    useEffect(() => {
        if (window) {
            setUrl(window.location.href);
        }
    }, []);

    return (
        <div className={classNames("mt-5", editorClassObj)} ref={ref} data-id={cmsId}>
            <div className="d-block d-sm-none mb-3">
                <div className="text-primary mb-2">
                    <small>SHARE THIS ARTICLE</small>
                </div>
                <ShareButtons url={url} size={48} round={false} gutterClass="mr-2" />
            </div>
            <div ref={ref} data-id={cmsId} className={classNames("position-relative", "main-image", "d-block", "d-sm-none", "mb-xl-3", "mb-2", editorClassObj)}>
                <Picture src={footerLogoSmall} alt="mountain america small" className="w-100" />
            </div>
            <div ref={ref} data-id={cmsId} className={classNames("position-relative", "main-image", "d-none", "d-sm-block", "mb-xl-3", "mb-2", editorClassObj)}>
                <Picture src={footerLogo} alt="mountain america" className="w-100" />
            </div>
            <div className="d-none d-sm-flex justify-content-between">
                <FacebookShareButton data-test-id="blog-share-btn-facebook" url={url} className={gutterClass}>
                    <Image loading="lazy" src={facebook} alt="facebook" />
                </FacebookShareButton>
                <TwitterShareButton data-test-id="blog-share-btn-twitter" url={url} className={gutterClass}>
                    <Image loading="lazy" src={x} alt="x" />
                </TwitterShareButton>
                <LinkedinShareButton data-test-id="blog-share-btn-linkedin" url={url} className={gutterClass}>
                    <Image loading="lazy" src={linkedin} alt="linkedin" />
                </LinkedinShareButton>
                <EmailShareButton data-test-id="blog-share-btn-email" url={url}>
                    <Image loading="lazy" src={email} alt="email" />
                </EmailShareButton>
            </div>
        </div>
    );
});

export default BlogFooterButtons;